import { StatisticQuerySourceOptions } from '@osos/shared/api';
import { DataEntrySourceModel } from '../data-entry-source';

import { GroupByOperatorEnum } from '../enums';
import {
  AggregationFunctionEnum,
  ChartTypeEnum,
  SortDirEnum,
  StatisticsQueryDisplay,
} from '../enums/statistics-enums';
import { FilterExpressionModel } from '../filter-expression.model';
import { IconModel } from '../icon.model';
import { LocalizedValueModel } from '../localized-value.model';
import { LiteDataModulePresenterModel } from './data-module-presenter.model';
import { LiteDataEntityPresenterModel } from './entity-presenter.model';

export class StatisticQueryPresenterModel {
  id?: string;
  aggregation: StatisticsQueryAggregationModel;
  chartType?: ChartTypeEnum;
  dataEntity: string;
  filterField?: string | null;
  description?: LocalizedValueModel;
  icon: IconModel;
  name: LocalizedValueModel;
  orderBy: SortDirEnum;
  showAs: StatisticsQueryDisplay;
  source: DataEntrySourceModel;
  sourceOptions?: StatisticQuerySourceOptions;
  options?: StatisticQueryOptionsModel;
  specificationVersion: number;
  showInEntityOverview: boolean;
  relatedData?: StatisticQueryDtoRelatedDataModel;
}
export interface StatisticQueryOptionsModel {
  colors?: string[];
}

export interface StatisticQueryResultItemModel {
  category?: any;
  result?: any;
  originalCategory?: any;
  subCategory?: any[];
}

export interface StatisticQueryResultModel {
  count: number;
  result: StatisticQueryResultItemModel[];
  query: FilterExpressionModel;
  hash?: string;
}

export class StatisticQueryDtoRelatedDataModel {
  dataEntity?: LiteDataEntityPresenterModel;
  dataModule?: LiteDataModulePresenterModel;
}

export class StatisticsQueryAggregationModel {
  aggregationFunction: AggregationFunctionEnum;
  field?: string;
  groupByField?: string[];
  groupByOperator?: GroupByOperatorEnum;
}

export enum StatisticQuerySourceParameterValueTypeEnum {
  Fixed = 0,
  Expression = 1,
}
